var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc24Trophy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M18 2a1 1 0 0 1 .997 1.083L18.92 4H21a1 1 0 0 1 1 1v4a4 4 0 0 1-3.97 4A8.482 8.482 0 0 1 15 17.513L14.999 20H19a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h3.999L9 17.514l-.233-.185A8.469 8.469 0 0 1 5.969 13a4 4 0 0 1-3.964-3.794L2 9V5a1 1 0 0 1 .883-.993L3 4h2.079l-.076-.917A1 1 0 0 1 6 2h12Zm-1.087 2H7.087l.61 7.324a6.467 6.467 0 0 0 2.858 4.844A1 1 0 0 1 11 17v3h2v-3a1 1 0 0 1 .43-.821l.217-.151a6.467 6.467 0 0 0 2.656-4.704L16.913 4ZM5.246 6H4v3a2 2 0 0 0 1.661 1.971L5.246 6ZM20 9V6h-1.247l-.414 4.971A2 2 0 0 0 20 9Z",
  clipRule: "evenodd"
})));
export default SvgIc24Trophy;